<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path clip-rule="evenodd" d="M5.297 2.165A.2.2 0 0 0 5 2.34v19.32a.2.2 0 0 0 .297.175l17.388-9.66a.2.2 0 0 0 0-.35L5.297 2.165Z">
    </path>
</svg>
